import { apiGet, apiPost } from '@/lib/http/client';

import type { MailchimpInstallResponse } from '../types';

export async function getMailchimpInstallUrl(
  orgId: number | string
): Promise<MailchimpInstallResponse> {
  return apiGet<MailchimpInstallResponse>(
    `/api/orgs/${orgId}/mailchimp/install/`
  );
}

export async function disconnectMailchimp(
  orgId: number | string
): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>(
    `/api/orgs/${orgId}/mailchimp/disconnect/`,
    {}
  );
}
